import styled, { css } from "styled-components";
import { ClassNames, DayPicker } from "react-day-picker";
import { useEffect, useRef, useState } from "react";
import { ko } from "date-fns/locale";
import { format } from "date-fns";
import styles from "react-day-picker/dist/style.module.css";
import CustomButton from "../common/customButton";
import EraserIcon from "../icon/eraserIcon";
import ArrowLeftIcon from "../icon/arrowLeftIcon";
import ArrowRightIcon from "../icon/arrowRightIcon";
import API from "../../API/API";
import makePdf from "../../API/makePDF";
import makeHtmltoImage from "../../API/makePDF";
import CloseIcon from "../icon/closeIcon";
import { useNavigate } from "react-router-dom";
import { Image } from "../common/image";
import SelectComponent from "../common/selectComponent";
import DropdownComponent from "../common/dropdownComponent";
import AdminStatusDropdownComponent from "./adminStatusDropdownComponent";
import DrawingPen from "../icon/drawingPen";
import PencilIcon from "../icon/pencil";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2); /* 배경을 약간 어둡게 만듭니다. */
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 50vw;
  height: 40%;
  background-color: white;
  border-radius: 0.8vw;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 50vw;
  height: 100vh;
`;
const HeaderContainer = styled.div`
  display: flex;
  height: 14%;
  width: 45vw;
`;
const HeaderText = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
`;
const HeaderNameText = styled.div`
  font-size: 1.7vw;
  font-weight: 700;
  color: #ff7f3b;
`;
const HeaderInfoText = styled.div`
  font-size: 1.4vw;
  font-weight: 700;
`;
const MainContainer = styled.div`
  display: flex;
  /* outline: 1px solid red; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45vw;

  height: 72%;
`;
const MainBox = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  width: 45vw;
  height: 90%;
`;
const MainInfoBox = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f8f8f8;
  border-radius: 0.6vw;
  /* outline: 1px solid red; */
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.01),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.003);
  padding: 0.6vw 1vw 0.4vw 1vw;
  align-items: start;
  flex-direction: column;
  width: 14vw;
  height: 4vw;
  /* outline: 1px solid green; */
`;

const MainTitle = styled.div`
  font-size: 0.8vw;
  font-weight: 600;
  color: #696969;
`;
const MainInfo = styled.div`
  width: 100%;
  margin-top: -0.2vw;
  overflow: auto;
  height: 3vw;
  display: flex;
  align-items: center;
  justify-content: start;
  /* outline: 1px solid green; */
`;
const InputBox = styled.input.attrs({})<{}>`
  width: 100%;
  margin-top: 0.1vw;
  padding: 0vw 0.3vw 0vw 0.1vw;
  overflow: auto;
  height: 2.3vw;
  display: flex;
  align-items: center;
  justify-content: start;
  /* margin-left: 1vw; */
  font-size: 1vw;
  font-weight: 600;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 0.1vw solid #e3e3e3;
  border-radius: 0.3vw;
  &:hover {
    background-color: 0.1vw solid #ff7f3b;
  }
`;
const MainInfoText = styled.div`
  font-size: 1vw;
  display: flex;
  align-items: center;
  justify-content: start;
  font-weight: 600;
  height: 100%;
  text-align: center;
`;
const BottomBtn = styled.div`
  display: flex;
  align-items: start;
  justify-content: end;
  width: 90%;
  height: 20%;
`;
const BottomBtnAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 38%;
  /* outline: 1px solid green; */
`;
const DropdownBox = styled.div`
  margin-top: 0.2vw;
  display: flex;
  width: 12vw;
  height: 3vw;
`;
const AdminUserEditModal = (props: any) => {
  const {
    setUserEditModalVisible,
    userEditModalVisible,
    selectedItem,
    setSelectedItem,
    deactivateAccount,
    activateAccount,
    getUserList,
  } = props;

  const [onViewMode, setOnViewMode] = useState<boolean>(true);
  const [onEditMode, setOnEditMode] = useState<boolean>(false);

  const [userId, setUserId] = useState<any>(selectedItem.userId);
  const [name, setName] = useState<any>(selectedItem.name);
  const [contact, setContact] = useState<any>(selectedItem.contact);
  const [branchCode, setBranchCode] = useState<any>(
    selectedItem.branch.branchCode
  );
  const [password, setPassword] = useState<any>(selectedItem.password);
  const [empCod, setEmpCod] = useState<any>(selectedItem.empCod);
  const [status, setStatus] = useState<any>(selectedItem.status);
  const [id, setId] = useState<any>(selectedItem.id);
  const [branchName, setBranchName] = useState<any>(
    selectedItem.branch.branchName
  );
  const statusItem = [
    { status: "활성화", index: 0, id: "1" },
    { status: "비활성화", index: 1, id: "2" },
  ];

  // 모달 닫기
  const onModalVisible = () => {
    setUserEditModalVisible(false);
    getUserList();
  };

  // 보기 mode
  const onChageViewMode = () => {
    adminEditFecth();
    setOnViewMode(true);
    setOnEditMode(false);
    getUserList();
  };
  // 수정 mode
  const onChageEditMode = () => {
    setOnViewMode(false);
    setOnEditMode(true);
    getUserList();
  };
  const adminEditFecth = async () => {
    // if (status === 0) {
    //   //활성화
    //   activateAccount(id);
    // } else if (status === 1) {
    //   //비활성화
    //   deactivateAccount(id);
    // }
    try {
      const requestParam = {
        userId: selectedItem.userId,
        name: selectedItem.name,
        contact: selectedItem.contact,
        branchCode: selectedItem.branchCode,
        password: selectedItem.password,
        empCod: selectedItem.empCod,
      };

      const response = await API.put(`/user/${id}`, requestParam);
      if (response.status === 200) {
        alert("정상적으로 변경되었습니다.");
      } else {
        alert("변경에 실패하였습니다. 다시 시도해주세요");
      }
    } catch (error) {
      alert(error);
    }
    getUserList();
    // }
  };

  // if (status === 0) {
  //   activateAccount(statusItem[status].id, statusItem[status].status);
  // } else if (status === 1) {
  //   deactivateAccount(statusItem[status].id, statusItem[status].status);
  // }
  useEffect(() => {
    setSelectedItem((prev: any) => {
      const updatedData = { ...prev };
      updatedData.password = password;
      updatedData.name = name;
      updatedData.contact = contact;
      updatedData.status = status + 1;
      return updatedData;
    });
  }, [password, name, contact, status]);

  return (
    <>
      <Backdrop />
      <Wrapper>
        <Container>
          <HeaderContainer>
            <HeaderText>
              <HeaderNameText>
                <PencilIcon
                  width={"1.5vw"}
                  height={"1.5vw"}
                  fill={"#ff7f3b"}
                ></PencilIcon>
              </HeaderNameText>
              <HeaderInfoText>&nbsp;{"계정 정보 수정"}</HeaderInfoText>
            </HeaderText>
          </HeaderContainer>
          <MainContainer>
            {onViewMode && (
              <MainBox>
                <MainInfoBox>
                  <MainTitle>이름</MainTitle>
                  <MainInfo>
                    <MainInfoText>{name}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>전화번호</MainTitle>
                  <MainInfo>
                    <MainInfoText>{contact}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                {/* <MainInfoBox>
                  <MainTitle>활성화</MainTitle>
                  <MainInfo>
                    <MainInfoText>{status}</MainInfoText>
                  </MainInfo>
                </MainInfoBox> */}
                <MainInfoBox>
                  <MainTitle>아이디</MainTitle>
                  <MainInfo>
                    <MainInfoText>{userId}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>비밀번호</MainTitle>
                  <MainInfo>
                    <MainInfoText>{password}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                {/* <MainInfoBox>
                  <MainTitle>사원코드</MainTitle>
                  <MainInfo>
                    <MainInfoText>{branchCode}</MainInfoText>
                  </MainInfo>
                </MainInfoBox> */}
                <MainInfoBox>
                  <MainTitle>지점이름(지점코드)</MainTitle>
                  <MainInfo>
                    <MainInfoText>
                      {branchName}({branchCode})
                    </MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>직원코드</MainTitle>
                  <MainInfo>
                    <MainInfoText>{empCod}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
              </MainBox>
            )}
            {onEditMode && (
              <MainBox>
                <MainInfoBox>
                  <MainTitle>이름</MainTitle>
                  <InputBox
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  ></InputBox>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>전화번호</MainTitle>
                  <InputBox
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  ></InputBox>
                </MainInfoBox>

                <MainInfoBox>
                  <MainTitle>아이디</MainTitle>
                  <MainInfo>
                    <MainInfoText>{userId}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>비밀번호</MainTitle>
                  <InputBox
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  ></InputBox>
                </MainInfoBox>
                {/* <MainInfoBox>
                  <MainTitle>사원코드</MainTitle>
                  <MainInfo>
                    <MainInfoText>{branchCode}</MainInfoText>
                  </MainInfo>
                </MainInfoBox> */}
                <MainInfoBox>
                  <MainTitle>지점이름</MainTitle>
                  <MainInfo>
                    <MainInfoText>{branchName}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
                <MainInfoBox>
                  <MainTitle>지점코드</MainTitle>
                  <MainInfo>
                    <MainInfoText>{empCod}</MainInfoText>
                  </MainInfo>
                </MainInfoBox>
              </MainBox>
            )}
          </MainContainer>
          <BottomBtn>
            <BottomBtnAlign>
              <CustomButton
                width={"8vw"}
                height={"2.4vw"}
                text={`닫기`}
                size={"1vw"}
                $bgColor={"#ffffff"}
                $border={"0.15vw solid #dcdcdc"}
                color={"#333333"}
                radius={"0.3vw"}
                onClick={onModalVisible}
              ></CustomButton>
              {onViewMode && (
                <CustomButton
                  width={"8vw"}
                  height={"2.4vw"}
                  text={`수정`}
                  size={"1vw"}
                  radius={"0.3vw"}
                  onClick={onChageEditMode}
                ></CustomButton>
              )}
              {onEditMode && (
                <CustomButton
                  width={"8vw"}
                  height={"2.4vw"}
                  text={`저장`}
                  size={"1vw"}
                  radius={"0.3vw"}
                  onClick={onChageViewMode}
                ></CustomButton>
              )}
            </BottomBtnAlign>
          </BottomBtn>
        </Container>
      </Wrapper>
    </>
  );
};

export default AdminUserEditModal;
